var _ellipse, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeofencingactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0013,
    cy: 8.83333,
    rx: 5.83333,
    ry: 5.83333,
    stroke: "#111111",
    strokeWidth: 1.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 14.3018C4.90568 16.06 7.19255 17.1665 9.73786 17.1665C14.4843 17.1665 18.332 13.3188 18.332 8.57233C18.332 6.02702 17.2255 3.74016 15.4673 2.1665",
    stroke: "#111111",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83203 4.29402C6.31968 4.75454 7.32425 6.0133 7.44129 7.36416C7.55068 8.62685 8.35435 9.65287 9.58203 9.66677C10.0538 9.67211 10.531 9.31865 10.5298 8.82935C10.5294 8.67805 10.5053 8.52335 10.4676 8.38102C10.4152 8.18306 10.4106 7.95532 10.5195 7.72235C10.9007 6.90733 11.6504 6.68841 12.2444 6.24579C12.5079 6.04948 12.7482 5.84239 12.8542 5.67558C13.1468 5.21506 13.4394 4.29402 13.2931 3.8335",
    stroke: "#111111",
    strokeWidth: 1.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.832 9.6665C15.649 10.1837 15.5195 11.5415 13.4533 11.5631C13.4533 11.5631 11.6235 11.5631 11.0745 12.5975C10.6354 13.4251 10.8915 14.3217 11.0745 14.6665",
    stroke: "#111111",
    strokeWidth: 1.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.8332V17.1665",
    stroke: "#111111",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 18.8335H8.33203",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 18.8335H10",
    stroke: "#111111",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeofencingactive);
export default __webpack_public_path__ + "static/media/Geofencing active.e0a8fc0a26c4e18a2540f9739d0aead0.svg";
export { ForwardRef as ReactComponent };